import { IFilter } from '@prishapolicy/shared/ui';
import { insurers } from '../../insurers';
export interface ResourceDataType {
  name: string;
  description: string;
  insuranceCategory: string;
  resourceCategory: string;
  brand: string;
  product: string;
  image: () => JSX.Element;
  resourceLink: string;
}

const brandFilterGroup = insurers.map((insurer) => {
  return {
    value: insurer,
  };
});

export const resourceFilters: Array<IFilter<ResourceDataType>> = [
  {
    groupName: 'Brand',
    allowedMultipleFilters: true,
    // filterGroup: [
    //   {
    //     value: 'ICICI Lombard',
    //   },
    //   {
    //     value: 'Digit Insurance',
    //   },
    //   {
    //     value: 'HDFC ERGO',
    //   },
    //   {
    //     value: 'New India Assurance',
    //   },
    //   {
    //     value: 'Tata AIG',
    //   },
    // ]
    filterGroup: brandFilterGroup.map((v) => ({
      ...v,
      displayName: v.value,
      filterFunction: (resource: ResourceDataType) => v.value === resource.brand,
    })),
  },
  {
    groupName: 'Type',
    allowedMultipleFilters: true,
    filterGroup: [
      {
        displayName: 'Policy brochure',
        value: 'Policy brochure',
        filterFunction: (resources: ResourceDataType) => resources.resourceCategory === 'Policy Brochure',
      },
      {
        displayName: 'Policy wordings',
        value: 'Policy wordings',
        filterFunction: (resources: ResourceDataType) => resources.resourceCategory === 'Policy Wording',
      },
      {
        displayName: 'Claim form',
        value: 'Claim form',
        filterFunction: (resources: ResourceDataType) => resources.resourceCategory === 'Claim Form',
      },
      {
        displayName: 'Proposal form',
        value: 'Proposal form',
        filterFunction: (resources: ResourceDataType) => resources.resourceCategory === 'Proposal Form',
      },
    ],
  },
  {
    groupName: 'Product',
    allowedMultipleFilters: true,
    filterGroup: [
      //productFilterGroup
      {
        displayName: 'Engineering Insurance',
        value: 'Engineering Insurance',
        filterFunction: (resources: ResourceDataType) => resources.insuranceCategory === 'Engineering',
      },
      {
        displayName: 'Fire Insurance',
        value: 'Fire Insurance',
        filterFunction: (resources: ResourceDataType) => resources.insuranceCategory === 'Fire',
      },
      {
        displayName: 'Health Insurance',
        value: 'Health Insurance',
        filterFunction: (resources: ResourceDataType) => resources.insuranceCategory === 'Health',
      },
      {
        displayName: 'Marine Insurance',
        value: 'Marine Insurance',
        filterFunction: (resources: ResourceDataType) => resources.insuranceCategory === 'Marine',
      },
      {
        displayName: 'Motor Insurance',
        value: 'Motor Insurance',
        filterFunction: (resources: ResourceDataType) => resources.insuranceCategory === 'Motor',
      },
    ],
  },
];
